var map = {
	"./Approved.png": 480,
	"./Bonus-w.png": 481,
	"./E-Wallet-w.png": 482,
	"./Paid-w.png": 483,
	"./Pending-w.png": 484,
	"./Rejected.png": 485,
	"./income-w.png": 486,
	"./logo_default.png": 487,
	"./logo_icon.png": 488,
	"./logo_login.png": 489,
	"./paid.png": 490,
	"./pending.png": 491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;